import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("nx_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      sessionStorage.removeItem("nx_token");
      sessionStorage.removeItem("nx_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);
